<template>
    <div role="application" class="bg-gray-800 h-screen flex align-items-center justify-content-center">
        <div class="p-5 w-11 md:w-6 lg:w-3">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {};
</script>
